import { HttpClient } from '@angular/common/http';
import { Component, effect, inject, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EnrichedPack } from '../../model/pack';
import { NotificationService } from 'src/app/core/services/notification.service';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { UpdateCompanyInfoComponent } from './update-company-info/update-company-info.component';
import { CurrentUserService } from '../../services/current-user.service';
import { GreentripperLoaderComponent } from '../greentripper-loader/greentripper-loader.component';
import { PageHeaderComponent } from '../page-header/page-header.component';
import { PackSelectorComponent } from './pack-selector/pack-selector.component';

@Component({
  selector: 'app-manage-subscription',
  imports: [
    UpdateCompanyInfoComponent,
    GreentripperLoaderComponent,
    PageHeaderComponent,
    TranslocoPipe,
    PackSelectorComponent,
  ],
  templateUrl: './manage-subscription.component.html',
})
export class ManageSubscriptionComponent implements OnInit {
  http = inject(HttpClient);
  notificationService = inject(NotificationService);
  translocoService = inject(TranslocoService);
  currentUserService = inject(CurrentUserService);
  url = `${environment.apiUrl}/pack-list`;
  packList: EnrichedPack[] = [];
  loading: boolean = false;
  showUpdateCompanyInfo = false;
  selectedPack: EnrichedPack | null = null;

  constructor() {
    effect(() => {
      if (!this.selectedPack) {
        this.selectedPack = this.currentUserService.pack() ?? null;
      }
    });
  }

  ngOnInit() {
    this.loadPackList();
  }

  loadPackList() {
    this.loading = true;
    this.http.get<EnrichedPack[]>(this.url).subscribe({
      next: (packlist) => {
        this.packList = packlist.filter((pack) => pack.code !== 'FREE');
        this.loading = false;
        this.showUpdateCompanyInfo = false;
      },
      error: (response) => {
        console.log(response.error);
        if (response.error.code === 'E_MISSING_COMPANY_INFO') {
          this.showUpdateCompanyInfo = true;
        } else {
          this.notificationService.error(
            this.translocoService.translate(
              'subscriptionPage.error.loadingPack',
            ),
          );
        }
        this.loading = false;
      },
    });
  }
}
